import React, { useContext, useState, useRef } from 'react';
import { CartContext } from '../../Context/CartContext';
import NumberFormat from 'react-number-format';
import { FaPencilAlt, FaCircle, FaAngleDown, FaCheckCircle } from 'react-icons/fa';
import onClickOutside from 'react-cool-onclickoutside';
import CabintypeSelect from './CabintypeSelect';
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card';
import NumberInput from '../FormFields/NumberInput';

function CabinSummary(props) {
  const cardBodyClass = "w-10/12 mx-auto";
  const cardBodyDiv = "pl-8 py-6";
  const innerWrapperClass = "flex items-center px-2 py-1 ";
  const labelClass = "text-xs w-32 p-1";
  const defaultInputClass = "z-40 w-full ";

  const [cart, setCart] = useContext(CartContext);

  const [currentIncludedInfo, setCurrentIncludedInfo] = useState(-1);
  const includedInfoRef = useRef();
  onClickOutside(includedInfoRef, () => setCurrentIncludedInfo(-1));
  const [currentCabintypeId, setCurrentCabintypeId] = useState(-1);
  const cabintypeRef = useRef();
  onClickOutside(cabintypeRef, () => setCurrentCabintypeId(-1));
  const [showCabintypeSelect, setShowCabintypeSelect] = useState(-1);
  const ref = useRef();
  onClickOutside(ref, () => setShowCabintypeSelect(-1));
  const [editCabin, setEditCabin] = useState(-1);
  const editCabinRef = useRef();
  onClickOutside(editCabinRef, () => setEditCabin(-1));
  const [currentDeckNumber, setCurrentDeckNumber] = useState(0);
  const colorClass = ["bg-cruise_cyan", "bg-cruise_orange", "bg-cruise_darkblue-30"];

  function getCabintypeClass(cabintypeId, cabin) {
    let cabintypeClass = "flex justify-between border-2 py-1 px-8 shadow cursor-pointer hover:bg-secondary-button-hover";
    if (cabintypeId === cabin.cabintypeId) {
      cabintypeClass += " bg-secondary-button";
    }
    return cabintypeClass;
  }
  function handleCategoryChange(id, price) {
    const category = props.master.cabinprimarytypes.find(x => x.id === id);
    if (category) {
      const updatedCart = { ...cart };
      updatedCart.cabins[editCabin]["cabintypeId"] = id;
      updatedCart.cabins[editCabin]["cabintypeName"] = category.name;
      updatedCart.cabins[editCabin]["price"] = price;
      setCart(updatedCart);
    }
  }
  function hasEqualPersons(obj1, obj2) {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    for (let objKey of obj1Keys) {
      if (objKey != "cabintypeId" && obj2Keys.includes(objKey)) {
        if (obj1[objKey] != obj2[objKey]) {
          return false;
        }
      }
    }

    return true;
  }
  function getCurrentDeckImage() {
    const defaultImage = props.master.pictureserver + "ShipDeck/65/65491454e9cd42f59db96576876d4fb8_kr6vllegrkpwk.png";
    const deck = props.master.ship.decks.find(d => d.deckNumber === currentDeckNumber);
    if (deck && deck.decoMapImg) {
      return props.master.pictureserver + deck.decoMapImg;
    }
    return defaultImage;
  }
  function getCurrentDeckName() {
    if (props.master.ship.decks.length === 0) {
      return "no names in decklist!";
    }
    let deck = props.master.ship.decks.find(deck => deck.deckNumber === currentDeckNumber);
    if (deck) {
      return deck.name;
    }
    deck = props.master.ship.decks[0];
    setCurrentDeckNumber(deck.deckNumber);
    return deck.name;
  }
  function selectDeck(deckId, cabinId) {
    setCurrentDeckNumber(deckId);
    const updatedCart = { ...cart };
    const cabin = updatedCart.cabins.find(c => c.cabinId === cabinId);
    if (cabin) {
      cabin.deckId = deckId;
      setCart(updatedCart);
    }
  }
  function total() {
    let t = cart.cabins.reduce((a, b) => +a + b.price, 0);
    return parseInt(t);
  }
  function renderCabinSummary(cabin) {
    let info = "";
    let countAdults = 0;
    let countChildren = 0;
    if (cabin.adults) {
      countAdults += cabin.adults;
    }
    if (cabin.seniors) {
      countAdults += cabin.seniors;
    }
    if (cabin.children) {
      countChildren += cabin.children;
    }
    if (cabin.juniorChildren) {
      countChildren += cabin.juniorChildren;
    }
    if (cabin.infants) {
      countChildren += cabin.infants;
    }

    info = addInfo(countAdults, "adult", info);
    info = addInfo(countChildren, "child", info);
    return info;
  }
  function addInfo(numberOfPerson, nameOfPerson, currentInfo) {
    if (numberOfPerson > 0) {
      if (currentInfo.length > 0) currentInfo += ", ";
      currentInfo += numberOfPerson + " " + nameOfPerson;
      if (numberOfPerson > 1) {
        if (nameOfPerson.endsWith("hild")) currentInfo += "ren";
        else currentInfo += "s";
      }
    }

    return currentInfo;
  }
  function renderPrice(price) {
    return <NumberFormat
      value={price}
      decimalScale={0}
      displayType={'text'}
      decimalSeparator={','}
      thousandSeparator={'.'}
      prefix={'DKK '}
    />
  }
  function toggleIncludedInfo() {

  }
  function toggleEdit(index) {
    let updatedState = index;
    if (showCabintypeSelect === index) {
      updatedState = -1;
    }

    setShowCabintypeSelect(updatedState);
  }
  function toggleCabintypeInfo(cabintypeId) {
    if (cabintypeId === currentCabintypeId) {
      cabintypeId = -1;
    }
    setCurrentCabintypeId(cabintypeId);
  }
  function renderCategoryInfo(price) {
    let source = "";
    let title = "";
    let description = "";
    const category = props.master.ship.cabinCategories.find(x => x.cabinCategoryPrimaryType.id === currentCabintypeId);
    if (category && category.gallery.length > 0) {
      const img = category.gallery[0].images[0];
      source = props.master.pictureserver + img.filePath;
      title = img.title;
      description = img.description;
    }

    return (
      <div className="p-2">
        <div className="flex text-sm">
          <div className="w-1/2">
            {source
              ? <img alt="" src={source} />
              : "No image found."
            }
          </div>
          <div className="w-1/2">
            {
              title ?
                <React.Fragment>
                  <span className="px-2 font-semibold">{title}</span>
                  <div className="pl-4">{description}</div>
                </React.Fragment>
                : "No description found."
            }
          </div>
        </div>
        <div onClick={() => toggleIncludedInfo()}
          className="flex justify-between px-8 border-2 shadow ml-auto w-10/12 my-4 items-center cursor-pointer" >What's included? <FaAngleDown /></div>
        <div onClick={() => { handleCategoryChange(currentCabintypeId, price); setCurrentCabintypeId(-1) }}
          className="whitespace-no-wrap text-cruise_darkblue cursor-pointer bg-secondary-button w-32 text-center text-xs py-1 ml-auto hover:bg-secondary-button-hover">
          Select
        </div>
      </div>
    )
  }
  function renderCategories(cabin) {
    const cruisePackage = props.master.cruisePackages.find(p => p.id === cart.packageId);
    if (cruisePackage) {
      const grid = cruisePackage.priceGrids.find(x => hasEqualPersons(x, cabin));
      if (grid) {
        return (
          grid.priceGridRows.map((row) =>
            <React.Fragment key={row.cabinCategoryPrimaryTypeId}>
              <div onClick={() => toggleCabintypeInfo(row.cabinCategoryPrimaryTypeId)}
                className={getCabintypeClass(row.cabinCategoryPrimaryTypeId, cabin)}>
                <div className="w-1/2">
                  {props.master.cabinprimarytypes.find(t => t.id === row.cabinCategoryPrimaryTypeId).name}
                </div>
                <div>
                  <NumberFormat
                    value={row.priceGridCell.lowestPrice / 100}
                    decimalScale={0}
                    displayType={'text'}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={'DKK '}
                  />
                </div>
                <div className="self-center"><FaAngleDown /></div>
              </div>
              {currentCabintypeId === row.cabinCategoryPrimaryTypeId
                ? renderCategoryInfo(row.priceGridCell.lowestPrice / 100)
                : null
              }
            </React.Fragment>
          )
        );
      }
    }
  }
  function renderCardHeader(number, title) {
    return <div className="flex justify-between items-center cursor-pointer border py-2 hover:bg-secondary-button-hover">
      <div className="w-1/12 flex justify-end">
        <FaCircle className="absolute w-8" size="22" />
        <span className="relative text-white text-sm w-8 text-center" >{number}</span>
      </div>
      <span className="w-full px-10">{title}</span>
      <FaAngleDown className="w-1/12" />
    </div>
  }
  function renderYourCabin() {

    return cart.cabins.map((cabin, index) =>
      <div key={cabin + '_' + index} className={cardBodyDiv}>
        <div className="flex pb-2">
          <span className="font-bold text-base">Cabin {index + 1}</span>
          <span className="flex items-center cursor-pointer" onClick={() => setEditCabin(index)}>
            <span className="pl-4 pr-2 underline text-xs">Edit</span>
            <FaPencilAlt size={14} />
          </span>
        </div>
        {editCabin >= 0 && editCabin === index
          ? <div ref={editCabinRef} className="flex mt-2">
            <div className="w-5/12">
              <div className="font-semibold text-sm pb-2">Passengers:</div>
              <div>
                <NumberInput
                  wrapperClass={innerWrapperClass}
                  labelClass={labelClass}
                  numberInputClass={defaultInputClass}
                  id="adults"
                  name="adults"
                  label="Adults (18+)"
                  min={0}
                  value={cabin.adults}
                  onChange={(name, value) => props.onPassengerChange(name, value, editCabin)}
                  typeId={1}
                />
                <NumberInput
                  wrapperClass={innerWrapperClass}
                  labelClass={labelClass}
                  numberInputClass={defaultInputClass}
                  id="seniors"
                  name="seniors"
                  label="Seniors"
                  min={0}
                  value={cabin.seniors}
                  onChange={(name, value) => props.onPassengerChange(name, value, editCabin)}
                  typeId={1}
                />
              </div>
              <div>
                <NumberInput
                  wrapperClass={innerWrapperClass}
                  labelClass={labelClass}
                  numberInputClass={defaultInputClass}
                  id="children"
                  name="children"
                  label="Teens (12-18)"
                  min={0}
                  value={cabin.children}
                  onChange={(name, value) => props.onPassengerChange(name, value, editCabin)}
                  typeId={1}
                />
                <NumberInput
                  wrapperClass={innerWrapperClass}
                  labelClass={labelClass}
                  numberInputClass={defaultInputClass}
                  id="juniorChildren"
                  name="juniorChildren"
                  label="Children (2-12)"
                  min={0}
                  value={cabin.juniorChildren}
                  onChange={(name, value) => props.onPassengerChange(name, value, editCabin)}
                  typeId={1}
                />
                <NumberInput
                  wrapperClass={innerWrapperClass}
                  labelClass={labelClass}
                  numberInputClass={defaultInputClass}
                  id="infants"
                  name="infants"
                  label="Infants (0-2)"
                  min={0}
                  value={cabin.infants}
                  onChange={(name, value) => props.onPassengerChange(name, value, editCabin)}
                  typeId={1}
                />
              </div>
            </div>
            <div className="w-7/12">
              <div className="font-semibold text-sm pb-2">Type:</div>
              <div ref={cabintypeRef}>
                {renderCategories(cabin)}
              </div>
            </div>
          </div>
          : <div className="flex justify-between border shadow py-1 text-xs" >
            <div className="flex">
              <span className="flex w-16 justify-center items-center text-cruise_orange"><FaCheckCircle /></span>
              <span className="font-bold">{cabin.cabintypeName}:</span>
              <span className="font-bold px-2">{renderCabinSummary(cabin)}</span>
            </div>
            <span className="w-20">{renderPrice(cabin.price)}</span>
          </div>
        }
      </div>
    )
  }
  function renderLocation() {
    return <div className="pb-10">
      <div className={cardBodyClass}>
        <div className={cardBodyDiv} >Deck plan: {getCurrentDeckName()}</div>
      </div>
      <div className="flex">
        <div className="pr-10">
          <div className="flex justify-around pb-3">
            {cart.cabins.map((cabin, index) =>
              <div key={"cabin_" + index} className="flex items-center">
                <div className={colorClass[index] + " w-4 h-4"} ></div>
                <div className="px-2">{cabin.cabintypeName}</div>
              </div>
            )}
          </div>
          <img
            alt="ShipDeckImage" src={getCurrentDeckImage()}
          />
        </div>
        <div className="flex flex-col-reverse whitespace-no-wrap text-xs">
          {props.master.ship.decks.map((deck) =>
            <div key={deck.deckNumber} className="flex flex-row items-center pb-1">
              <div className="w-16 cursor-pointer" onClick={() => selectDeck(deck.deckNumber)}>
                <span className={deck.deckNumber === currentDeckNumber ? "font-semibold border-b-4 border-cruise_orange" : ""}>
                  Deck {deck.deckNumber}
                </span>
              </div>
              <div className="w-4 h-4 bg-cruise_cyan" ></div>
            </div>
          )}
        </div>
      </div>
      <div className={cardBodyClass}>

      </div>
    </div>
  }
  function renderConfirm() {
    return cart.cabins.map((cabin, index) =>
      <div key={cabin + '_' + index} className={cardBodyDiv}>
        <div className="font-bold text-lg pb-2">cabin {index + 1}</div>
        <div className="flex justify-between" >
          <div className="flex">
            <span className="font-bold">{cabin.cabintypeName}:</span>
            <span className="px-2">{renderCabinSummary(cabin)}</span>
            <div className="flex items-center cursor-pointer" onClick={() => toggleEdit(index)}>
              <span className="px-2 underline"> Edit </span><FaPencilAlt size={14} />
            </div>
          </div>
          <span>{renderPrice(cabin.price)}</span>
        </div>
        {showCabintypeSelect >= 0 && showCabintypeSelect === index
          ? <div>
            <CabintypeSelect
              cabin={cabin}
              cruisepackage={props.master.cruisePackages.find(x => x.id == cart.packageId)}
              ship={props.master.ship}
            />
          </div>
          : null}
      </div>
    )
  }

  return (
    <div ref={ref} className="flex flex-col w-full text-base">
      <Accordion defaultActiveKey="0">
        <Card >
          <Accordion.Toggle as={Card.Header} eventKey="0">
            {renderCardHeader(1, "Your cabin")}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={cardBodyClass} >
              {renderYourCabin()}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            {renderCardHeader(2, "Location")}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body >
              {renderLocation()}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            {renderCardHeader(3, "Confirm")}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body className={cardBodyClass}>
              {renderConfirm()}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <div className="flex justify-between pt-6 font-bold">
        <span >Total to pay</span>
        <span>{renderPrice(total())}</span>
      </div>
    </div>
  );
}

export default CabinSummary;